import { ScreenRoute } from "../ScreenRouteConstant";

export const newSubscriptionData = {
    route: ScreenRoute.acs_plans,
    paymentRoute: ScreenRoute.payment_online,
    image: '/images/dashboard_activate.png',
    widthToHeight: 5 / 12,
    valid: false,
}

export const purchasedSubscriptionData = {
    route: ScreenRoute.acs_current_plan,
    paymentRoute: ScreenRoute.payment_acs,
    image: '/images/dashboard_header_2.png',
    widthToHeight: 0.33,
    valid: true,
}

export const expiredSubscriptionData = {
    route: ScreenRoute.acs_plans,
    paymentRoute: ScreenRoute.payment_online,
    image: '/images/aayu_expired.png',
    widthToHeight: 0.33,
    valid: false,
}